import Link from 'next/link';
import React from 'react';
import tw, { styled, TwStyle } from 'twin.macro';
import * as footerTypes from '../../types/FooterTypes.type';

type StyledInnerSpanProps = {
  header: boolean;
};

type StyleLIProps = {
  bullet?: boolean;
  customStyle?: TwStyle[] | undefined;
};

export const FooterHeader = styled.p(() => [
  tw`text-gray-footer text-xs font-bold uppercase mb-1`,
]);

const StyledLI = styled.li(({ bullet, customStyle }: StyleLIProps) => [
  tw`text-gray-footer`,
  customStyle,
  bullet && tw`list-disc list-inside`,
]);

const InnerSpan = styled.span(({ header }: StyledInnerSpanProps) => [
  tw`mb-1 text-gray-footer capitalize`,
  header
  && tw`text-xs font-bold uppercase mb-1`,
]);

const InnerLink = styled.a(({ header }: StyledInnerSpanProps) => [
  tw`mb-1 text-gray-footer capitalize`,
  header
  && tw`text-xs font-bold uppercase mb-1`,
]);

export default function FooterLink(footerProps: footerTypes.FooterLinkProps) {
  const { customStyleLI } = footerProps;

  const {
    href, bullet, header, text,
  } = footerProps;
  if (href) {
    return (
      <StyledLI bullet={bullet} customStyle={customStyleLI}>
        <Link href={href} legacyBehavior>
          <InnerLink href={href} header={header}>{text}</InnerLink>
        </Link>
      </StyledLI>
    );
  }
  return (
    <StyledLI bullet={bullet}>
      <InnerSpan header={header}>{text}</InnerSpan>
    </StyledLI>
  );
}
